import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import BlockFeaturedContentSection from '@/ui/shared/blocks/BlockFeaturedContentSection.vue';
import { LeftRightAlignment } from '@/enums';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockFeaturedContent',
  props: {
    hideContent1: { type: Boolean },
    hideContent2: { type: Boolean },
    headline1: null,
    headline2: null,
    tag1: null,
    tag2: null,
    description1: null,
    description2: null,
    link1: null,
    link2: null,
    buttonText1: null,
    buttonText2: null,
    image1: null,
    image2: null,
    portraitMode: { type: Boolean },
    largeContentBlockPosition: null
  },
  setup(__props: any) {

const Alignment = LeftRightAlignment;



const isInEditMode = computed<boolean>(() => store.getters['app/isInEditMode']);

return { __sfc: true,Alignment, isInEditMode, BlockFeaturedContentSection }
}

})